import { render, staticRenderFns } from "./bind-project.vue?vue&type=template&id=c1af1f56&scoped=true"
import script from "./bind-project.vue?vue&type=script&lang=js"
export * from "./bind-project.vue?vue&type=script&lang=js"
import style0 from "./bind-project.vue?vue&type=style&index=0&id=c1af1f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1af1f56",
  null
  
)

export default component.exports